import React from "react";

export default () => (
  <section id="works">
    <div className="section_hexagon" />
    <div className="section_title">
      <p>WORKS</p>
      <h2>制作事例</h2>
    </div>
    <div className="section_contents">
      <div className="works_list">
        <div className="works_item">
          <a className="item" href="https://www.lyzon.co.jp/works/pickup/sumitomo/" target="blank" rel="noopener noreferrer">
            <div className="image">
              <picture>
                <source srcSet="images/works/sumitomo.webp" type="image/webp" />
                <img src="images/works/sumitomo.jpg" alt="true" />
              </picture>
            </div>
            <div className="text">
              <p className="title">住友商事株式会社様</p>
              <p className="description">グローバルサイト構築と<br />ワークフローのカスタマイズ</p>
            </div>
          </a>
        </div>
        <div className="works_item">
          <a className="item" href="https://www.lyzon.co.jp/works/pickup/nri/" target="blank" rel="noopener noreferrer">
            <div className="image">
              <picture>
                <source srcSet="images/works/nri.webp" type="image/webp" />
                <img src="images/works/nri.jpg" alt="true" />
              </picture>
            </div>
            <div className="text">
              <p className="title">株式会社野村総合研究所様</p>
              <p className="description">次世代タグ検索を導入した<br />サイトリニューアル構築</p>
            </div>
          </a>
        </div>
        <div className="works_item">
          <a className="item" href="https://www.lyzon.co.jp/works/pickup/seiko/" target="blank" rel="noopener noreferrer">
            <div className="image">
              <img src="images/works/seiko.webp" alt="true" />
            </div>
            <div className="text">
              <p className="title">
                セイコーウオッチ株式会社様
              </p>
              <p className="description">
                グローバル統合Web基盤の<br />2サイトを構築
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div className="works_more">
      <div className="more_box">
        <a
          rel="noopener noreferrer"
          href="https://www.lyzon.co.jp/ja-JP/works.aspx"
          target="_blank"
        >
          制作事例の一覧へ
        </a>
      </div>
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/Home/Works.js